import { render, staticRenderFns } from "./ResultsSurveys.vue?vue&type=template&id=2c82a19e&scoped=true"
import script from "./ResultsSurveys.vue?vue&type=script&lang=js"
export * from "./ResultsSurveys.vue?vue&type=script&lang=js"
import style0 from "./ResultsSurveys.vue?vue&type=style&index=0&id=2c82a19e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c82a19e",
  null
  
)

export default component.exports